"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Loading = function () { return (react_1.default.createElement("div", { className: "vh-100 media justify-content-center align-items-center" }, "Loading")); };
exports.Loading = Loading;
//# sourceMappingURL=index.js.map